export default {
  sb: {
    "take-away": "Huỷ",
    "please-input": "vui lòng nhập",
    "please-select": "Vui lòng chọn",
    "pack-up-screen": "Đóng bộ lọc",
    "more-screening": "Thêm bộ lọc",
    sure: "Xác nhận",
    reset: "Đặt lại",
    query: "Tra cứu",
    to: "ĐẾN",
    "start-date": "Ngày bắt đầu",
    "end-date": "Ngày kết thúc",
    "start-time": "Thời gian bắt đầu",
    "end-time": "Thời gian kết thúc",
    "please-enter-the-content": "Vui lòng nhập nội dung",
    "upload-video": "Tải video lên",
    "please-upload-video-file": "Vui lòng tải lên một video",
    "only-support-pm4": "Chỉ hỗ trợ tải lên các tập tin video ở định dạng MP4",
    "select-all": "Chọn tất cả trên trang này",
    "selected-n-item": "Đã chọn {num} mục",
    "query-by-day": "Truy vấn theo ngày",
    "query-by-month": "Truy vấn theo tháng"
  }
};
